import parserStringDateToDate from '../parserStringDateToDate'

const calculateDatesDifferenceInDays = (startDate: string, finalDate: string) => {
  if (!startDate || !finalDate) return 0

  const parsedStartDate = parserStringDateToDate(startDate)
  const parsedFinalDate = parserStringDateToDate(finalDate)

  const differenceDates = Number(parsedFinalDate) - Number(parsedStartDate)
  const differencesInDays = differenceDates / (1000 * 60 * 60 * 24)

  return differencesInDays
}

export default calculateDatesDifferenceInDays
